import React, { useEffect, useMemo, useState } from "react";
import SmuButton from "../../utils/smu-button/SmuButton";
import { Card } from "react-bootstrap";
import { IconDownload } from "../../icons/Icon";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import SmuSearch from "../../utils/smu-search/SmuSearch";
import SmuTable from "../../utils/smu-table/SmuTable";
import { prepareText } from "../../helpers";
import { downloadFile } from "../../api/files";
import iconPdf from "../../assets/images/dummy/icon-pdf.png";
import { toast } from "../../helpers/smu-alerts/smu-lerts";
import { MANUALS_CATEGORY } from "../../constants/categories";

const ManualsTable = ({ files, setFiles, loading }) => {
  const [search, setSearch] = useState("");
  const [handleFiles, setHandleFiles] = useState([]);
  const [dowloading, setDowloading] = useState(null);

  useEffect(() => {
    let _files = files;
    if (!!search) {
      const _search = prepareText(search);
      _files = files.filter((_file) => {
        const filename = prepareText(_file.filename);
        return filename.includes(_search);
      });
    }

    setHandleFiles(_files);
  }, [files, search]);

  const download = (file) => {
    setDowloading(file.id);

    downloadFile(MANUALS_CATEGORY, file.id)
      .then(({ data, error }) => {
        if (!!error) throw new Error(error?.message);

        const _files = files.map((f) => {
          if (f.id === file.id) f.views++;
          return f;
        });
        setFiles(_files);

        const {
          url,
          document: { filename },
        } = data;

        const element = document.createElement("a");
        element.setAttribute("href", url);
        element.setAttribute("download", filename);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      })
      .finally(() => setDowloading(null));
  };

  const columns = useMemo(
    () => [
      {
        name: "",
        selector: (row) => row.id,
        sortable: true,
        cell: (row) => (
          <div className="cell text-truncate">
            <img src={iconPdf} alt="FILE" className="ms-4" width={30} />
          </div>
        ),
        width: "120px",
      },
      {
        name: "Nombre archivo",
        selector: (row) => row.filename,
        sortable: true,
        cell: (row) => <div className="cell text-truncate">{row.filename}</div>,
        width: "40%",
      },
      {
        name: "Visualizado",
        selector: (row) => row.views,
        sortable: true,
        cell: (row) => (
          <div className="cell text-truncate">
            {Number(row.views) > 0 ? "Si" : "No"}
          </div>
        ),
      },
      {
        name: "Visualizaciones",
        selector: (row) => row.views,
        sortable: true,
        cell: (row) => <div className="cell text-truncate">{row.views}</div>,
      },
      {
        name: "Descargar",
        selector: (row) => row.id,
        sortable: true,
        cell: (row) => (
          <div className="cell text-truncate">
            <SmuButton
              _className="mx-auto"
              control={() => download(row)}
              loading={dowloading === row.id}
            >
              <IconDownload color="#33383F" />
            </SmuButton>
          </div>
        ),
        right: true,
      },
    ],
    [dowloading, files]
  );

  return (
    <Card className="smu-card">
      <Card.Header className="d-flex py-4">
        <div className="d-flex align-items-center me-auto">
          <SmuBadge color="#FFD88D" />
          <span className="fs-5 ms-3 me-auto">Manuales</span>
        </div>
        <div className="d-flex align-items-center ms-5">
          <SmuSearch
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
        </div>
      </Card.Header>
      <Card.Body>
        <SmuTable columns={columns} data={handleFiles} loading={loading}/>
      </Card.Body>
    </Card>
  );
};

export default ManualsTable;
